import React from 'react';
import { DynamicObjectType } from 'types/commons';
import { ShowWrapper } from './styles';
import { Col, Row } from 'antd';
import OrderSummary from './OrderSummary';
import LeftContent from './LeftContent';
import RightContent from './RightContent';

const ShowContent = ({ data }: { data: DynamicObjectType }) => {
  console.log(data);

  return (
    <ShowWrapper>
      <OrderSummary data={data} />
      <br />
      <Row gutter={[20, 20]}>
        <Col md={15}>
          <LeftContent data={data} />
        </Col>
        <Col md={9}>
          <RightContent data={data} />
        </Col>
      </Row>
    </ShowWrapper>
  );
};

export default ShowContent;
